import { z } from 'zod';

import { makeEndpoint } from '../common';

const processScheduledReportsResponseSchema = z.object({
  totalActiveBrands: z.number(),
  totalBrandsWithAutomations: z.number(),
  totalReportAutomations: z.number(),
  totalActiveReportAutomationsFromActiveBrands: z.number(),
  currentScheduled: z.object({
    brandsReceivingReports: z.number(),
    reportsToGenerateCount: z.number(),
    reportsToGeneratePercentage: z.number(),
    reportsByDateRange: z.record(z.number()),
  }),
});

export const ProcessScheduledReportsEndpoint = makeEndpoint({
  method: 'POST',
  url: () => 'report-automations/process-scheduled',
  responseSchema: processScheduledReportsResponseSchema,
  requestSchema: z.void(),
});
